import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import ZH_CN from 'vee-validate/dist/locale/zh_CN' // 引入中文包，提示信息可以以中文形式显示

Validator.localize(ZH_CN) // 设置提示信息中文方式显示

const config = {
  errorBagName: 'errors',
  fieldsBagName: 'fields',
  delay: 100,
  locale: 'zh_CN',
  strict: true,
  enableAutoClasses: true,
  events: 'blur',
  inject: true,
  validity: true
}

Vue.use(VeeValidate, config)
VeeValidate.Validator.localize({
  zh_CN: {
    messages: {
      required: function (name) { return name + '不能为空' },
      maxLength: function (name, length) { return name + '最长不能超过' + length + '位' }
    }
  }
})

VeeValidate.Validator.extend('name', {
  getMessage: function () { return '请输入字母、数字和汉字，且不以数字开头' },
  validate: function (value) { return /^[a-zA-Z\u4e00-\u9fa5]([\w\u4e00-\u9fa5]*)$/.test(value) }
})

VeeValidate.Validator.extend('tel', {
  getMessage: function () { return '请输入正确的手机号' },
  validate: function (value) { return /^1\d{10}$/.test(value) }
})
/**
 * 页面表单验证
 * @param validator 当前页面验证信息
 * @param success 验证成功
 * @param failure 验证失败，返回错误消息
 */
export const actionWithValidator = (validator, success, failure) => {
  validator.validateAll().then(result => {
    if (!result) {
      if (validator.errors.all().length !== 0) {
        failure(validator.errors.all()[0])
      } else {
        failure('验证失败')
      }
    } else {
      success()
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/validation.js